module.exports = __webpack_public_path__ + "img/share-front.41081dd7.png";